import React from 'react';
import { motion } from 'framer-motion';
import { OPENFINANCE_THEME } from '../../constants/openFinanceTheme';
export interface RedirectionScreenProps {
  targetName: string;
  targetType: 'LFI' | 'TPP';
  logoUrl?: string;
  sourceName?: string;
  sourceLogoUrl?: string;
}
export function RedirectionScreen({
  targetName,
  targetType
}: RedirectionScreenProps) {
  const isLFI = targetType === 'LFI';
  return <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #00BCD4 0%, #1976D2 50%, #0D47A1 100%)'
  }} data-id="element-1195">
      {/* Main Content */}
      <div className="relative z-10 text-center px-6 max-w-2xl" data-id="element-1196">
        {/* Animated Loading Spinner */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="mb-16" data-id="element-1197">
          <div className="relative w-32 h-32 mx-auto" data-id="element-1198">
            {/* Gradient ring spinner */}
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0" data-id="element-1199">
              <svg className="w-full h-full" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-1200">
                <defs data-id="element-1201">
                  <linearGradient id="spinnerGradient" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-1202">
                    <stop offset="0%" stopColor="#00BCD4" stopOpacity="1" data-id="element-1203" />
                    <stop offset="50%" stopColor="#4DD0E1" stopOpacity="0.8" data-id="element-1204" />
                    <stop offset="100%" stopColor="#00BCD4" stopOpacity="0.3" data-id="element-1205" />
                  </linearGradient>
                </defs>
                <circle cx="50" cy="50" r="40" stroke="url(#spinnerGradient)" strokeWidth="6" strokeLinecap="round" strokeDasharray="180 70" fill="none" data-id="element-1206" />
              </svg>
            </motion.div>

            {/* Inner glow effect */}
            <motion.div animate={{
            scale: [1, 1.1, 1],
            opacity: [0.4, 0.6, 0.4]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="absolute inset-0 rounded-full" style={{
            background: 'radial-gradient(circle, rgba(77, 208, 225, 0.3) 0%, transparent 70%)'
          }} data-id="element-1207" />
          </div>
        </motion.div>

        {/* Redirect Message */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-1208">
          <h1 className="text-white text-lg md:text-xl font-normal leading-relaxed" style={{
          fontFamily: OPENFINANCE_THEME.fonts.body
        }} data-id="element-1209">
            {isLFI ? <>
                You'll be redirected to{' '}
                <span className="font-bold" data-id="element-1210">{targetName}</span>,
                <br data-id="element-1211" />
                don't close this window
              </> : <>
                You'll be redirected back to{' '}
                <span className="font-bold" data-id="element-1212">{targetName}</span>,
                <br data-id="element-1213" />
                don't close this window
              </>}
          </h1>
        </motion.div>
      </div>

      {/* ALTAREQ Footer Branding */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.4
    }} className="absolute bottom-16 left-0 right-0 flex flex-col items-center gap-4" data-id="element-1214">
        <div className="text-white text-base opacity-90" style={{
        fontFamily: OPENFINANCE_THEME.fonts.body
      }} data-id="element-1215">
          Powered by
        </div>

        {/* ALTAREQ Logo SVG */}
        <img src="https://cdn.magicpatterns.com/uploads/fGMtEsLeHZt6m9wLuSFi4B/Dark_Logo.svg" alt="ALTAREQ" className="h-16 w-auto object-contain" data-id="element-1216" />
      </motion.div>
    </div>;
}